import { gql } from '@apollo/client';
import { StationLoadingDetailDto } from './getStationLoadingDetails';

/** 提单信息字段集，单查与 BOL v3 合并查询复用 */
const BOL_INFO_FIELDS = `
            id
            taskId
            bolNumber
            freightOrderId
            segment
            routeName
            routeCode
            taskDate
            shipFromWarehouseId
            shipFromWarehouseSortingCode
            shipFromAddress
            shipFromCityStateZipcode
            shipFromContactName
            shipFromContactPhoneNumber
            shipToWarehouseId
            shipToWarehouseSortingCode
            shipToAddress
            shipToCityStateZipcode
            shipToContactName
            shipToContactPhoneNumber
            carrierId
            carrierName
            trailerNumber
            truckNumber
            vehicleNumber
            proNumbers
            nextStopArrivalAt
            nextStopLocalTimezone
            nextStopTimezoneLocation
            planArrivalLocalDate
            planArrivalLocalTime
            sealNumber
            staticEtaDate
            staticEtaTime
            vehicleModel
            vehicleTypeName
            driver1Id
            driver1Name
            driver1Phone
            driver2Id
            driver2Name
            driver2Phone
            licensePlate
            createdAt
            updatedAt
`;

/**
 * BOL v3 打印数据：提单信息 + 装车明细一次请求取回，两个 root field 由服务端并发执行。
 * 原先装车明细是 BolPreviewModal 打开后再单独查，串行且预览刚开时 loadingDetails 为空，
 * 此刻点打印会打出没有 Loading Information 的单子。
 */
export const GET_BOL_PRINT_DATA = gql`
    query GetBolPrintData($taskId: ID!, $taskIdLong: Long!) {
        getTmsTaskBolInfosByTaskId(taskId: $taskId) {
            ${BOL_INFO_FIELDS}
        }
        getStationLoadingDetailsByTaskId(taskId: $taskIdLong) {
            stationCode
            bags {
                bagNumber
                parcelCount
                weightKg
            }
            containers {
                containerType
                containerCount
            }
        }
    }
`;

export const GET_TMS_TASK_BOL_INFOS = gql`
    query GetTmsTaskBolInfos($taskId: ID!) {
        getTmsTaskBolInfosByTaskId(taskId: $taskId) {
            id
            taskId
            bolNumber
            freightOrderId
            segment
            routeName
            routeCode
            taskDate
            shipFromWarehouseId
            shipFromWarehouseSortingCode
            shipFromAddress
            shipFromCityStateZipcode
            shipFromContactName
            shipFromContactPhoneNumber
            shipToWarehouseId
            shipToWarehouseSortingCode
            shipToAddress
            shipToCityStateZipcode
            shipToContactName
            shipToContactPhoneNumber
            carrierId
            carrierName
            trailerNumber
            truckNumber
            vehicleNumber
            proNumbers
            nextStopArrivalAt
            nextStopLocalTimezone
            nextStopTimezoneLocation
            planArrivalLocalDate
            planArrivalLocalTime
            sealNumber
            staticEtaDate
            staticEtaTime
            vehicleModel
            vehicleTypeName
            driver1Id
            driver1Name
            driver1Phone
            driver2Id
            driver2Name
            driver2Phone
            licensePlate
            createdAt
            updatedAt
        }
    }
`;

export interface TmsTaskBolInfoType {
    id: string;
    taskId: string;
    bolNumber: string;
    freightOrderId?: string;
    segment: number;
    routeName?: string;
    routeCode?: string;
    taskDate?: string;
    shipFromWarehouseId?: string;
    shipFromWarehouseSortingCode?: string;
    shipFromAddress?: string;
    shipFromContactName?: string;
    shipFromContactPhoneNumber?: string;
    shipToWarehouseId?: string;
    shipToWarehouseSortingCode?: string;
    shipToAddress?: string;
    shipToContactName?: string;
    shipToContactPhoneNumber?: string;
    carrierId?: string;
    carrierName?: string;
    trailerNumber?: string;
    truckNumber?: string;
    vehicleNumber?: string;
    proNumbers?: string;
    nextStopArrivalAt?: string;
    nextStopLocalTimezone?: string;
    nextStopTimezoneLocation?: string;
    planArrivalLocalDate?: string;
    planArrivalLocalTime?: string;
    sealNumber?: string;
    staticEtaDate?: string;
    staticEtaTime?: string;
    vehicleModel?: string;
    vehicleTypeName?: string;
    driver1Id?: string;
    driver1Name?: string;
    driver1Phone?: string;
    driver2Id?: string;
    driver2Name?: string;
    driver2Phone?: string;
    licensePlate?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface GetTmsTaskBolInfosResponse {
    getTmsTaskBolInfosByTaskId: TmsTaskBolInfoType[];
}

export interface GetBolPrintDataResponse extends GetTmsTaskBolInfosResponse {
    getStationLoadingDetailsByTaskId: StationLoadingDetailDto[];
}

/**
 * 同一个 taskId 传两遍，只是标量壳子不同：
 * getTmsTaskBolInfosByTaskId 收 ID!、getStationLoadingDetailsByTaskId 收 Long!，
 * GraphQL 要求变量类型与参数类型是同一具名类型（无隐式转换），一个变量喂不了两个字段。
 * 后端把前者入参从 ID 改成 Long 即可合并成一个变量，属 schema 变更，本次未做。
 */
export interface GetBolPrintDataVariables {
    taskId: string;
    taskIdLong: number;
}
